<template>
  <div class="p-prepare" :class="isPad?'is-pad':''">
    <card-header v-show="!isPad">备课中心</card-header>
    <el-tabs
      v-model="activeName"
      @tab-click="onTabClick"
      class=" i-tab"
      :class="offsetClass + ' '+(isPad?'hide-header':'mt-24')">
      <el-tab-pane
        :label="item.label"
        :name="item.name"
        lazy
        v-for="item in tabList"
        :key="item.name">
          <component ref="PreviewRecord" :is="item.component" />
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
/* eslint-disable */
import CardHeader from '@/components/card-header.vue';
import CourseResource from './components/course-resource.vue';
import PreviewRecord from './components/preview-record.vue';

export default {
  name: 'LessonPrepare',
  components: {
    CardHeader,
  },
  data() {
    return {
      isPad: this.$route.query.spad,
      activeName: 'resource',
      offsetClass: 'l-0',
      tabList: [{
        label: '章节资源',
        name: 'resource',
        component: CourseResource,
      }, {
        label: '预习记录',
        name: 'pre-record',
        component: PreviewRecord,
      }],
    };
  },
  watch: {
    '$store.state.activeName': function (newVal) {
      if (newVal === 'pre-record') {
        // this.activeName = newVal;
        this.$nextTick(() => {
          const map = {
            resource: 'l-0',
            'pre-record': 'l-1',
          };
          this.activeName = newVal;
          this.offsetClass = map[newVal];
          this.$refs.PreviewRecord[1].getEvaluateList();
        });
      }
    },
  },
  methods: {
    onTabClick(e) {
      this.offsetClass = `l-${e.index}`;
      this.$store.commit('changeActive', 'resource');
    },
  },
};
</script>

<style lang="scss" scoped>
.p-prepare{
  padding: 32px 32px 10px;
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  background: #fff;
  position: relative;
  &.is-pad {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.is-pad /deep/ {
  .f-left {
    height: 100vh;
    box-sizing: border-box;
    min-height: unset;
    overflow-y: auto;
  }
  .f-main {
    min-height: unset;
    height: calc(100vh - 50px);
    box-sizing: border-box;
  }
  .topic-resource .el-pagination {
    position: fixed;
    bottom: 10px;
    left: 300px;
    width: 600px;
  }
}
// element tag 样式覆盖
.i-tab {
  /deep/ {
    .el-tabs__item {
      font-size: 17px;
      width: 100px;
      text-align: center;
      height: 56px;
      line-height: 56px;
      padding: 0 !important;
      margin: 0 20px;
      &.is-active {
        color: rgba(25, 137, 250, 1);
      }
    }
    .el-tabs__nav-wrap {
      overflow: visible;
      display: flex;
    }
    .el-tabs__nav-scroll {
      overflow: visible;
    }
    .el-tabs__active-bar {
      background-color: rgba(25, 137, 250, 1);
      height: 3px;
      border-radius: 2px;
      width: 100px !important;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 13px;
        height: 13px;
        border: 2px solid rgba(25, 137, 250, 1);
        box-sizing: border-box;
        background: #fff;
        border-radius: 50%;
        top: -4px;
      }
    }
  }
}
.l-0 /deep/{
  .el-tabs__active-bar {
    left: 18px;
  }
}
.l-1 /deep/ {
  .el-tabs__active-bar {
    left: 54px;
  }
}
.l-2 /deep/ {
  .el-tabs__active-bar {
    left: 96px;
  }
}
 /deep/ .hide-header > .el-tabs__header {
  display: none;
}
</style>
